/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const KubernetesTargetAuthKubernetesTargetTokenAuthKindEnum = {
    Token: 'Token'
};
/**
 * Check if a given object implements the KubernetesTargetAuthKubernetesTargetTokenAuth interface.
 */
export function instanceOfKubernetesTargetAuthKubernetesTargetTokenAuth(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function KubernetesTargetAuthKubernetesTargetTokenAuthFromJSON(json) {
    return KubernetesTargetAuthKubernetesTargetTokenAuthFromJSONTyped(json, false);
}
export function KubernetesTargetAuthKubernetesTargetTokenAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
        'kind': json['kind'],
    };
}
export function KubernetesTargetAuthKubernetesTargetTokenAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
        'kind': value['kind'],
    };
}
